import { Calendar, ExternalLink } from 'lucide-react';
import styles from './booking.module.css';

const CALENDLY_URL = 'https://calendly.com/yoavron';

export function BookingPage() {
  return (
    <div className={styles.page}>
      <header className={styles.head}>
        <div>
          <h1>יומן ופגישות</h1>
          <p className={styles.sub}>פגישות מתוזמנות + לוח שבועי. M-P24 יחבר את Calendly עם sync דו-כיווני, התראת meeting_soon 30 דקות לפני, וזיהוי לידים אוטומטי.</p>
        </div>
        <Calendar size={32} className={styles.headIcon} aria-hidden="true" />
      </header>

      <div className={styles.emptyCard}>
        <Calendar size={64} className={styles.bigIcon} aria-hidden="true" />
        <h2>עוד אין פגישות מתוזמנות</h2>
        <p>כרגע ההזמנות עוברות דרך Calendly. בגרסה הבאה הן יסונכרנו אוטומטית למסך הזה.</p>
        <a href={CALENDLY_URL} target="_blank" rel="noreferrer noopener" className={styles.btnPrimary}>
          <ExternalLink size={16} aria-hidden="true" />
          פתח Calendly
        </a>
      </div>

      <div className={styles.featureGrid}>
        <div className={styles.feature}>
          <h3>פגישות השבוע</h3>
          <p>כל הפגישות שתוזמנו, מסודרות לפי יום ושעה.</p>
        </div>
        <div className={styles.feature}>
          <h3>זיהוי לידים</h3>
          <p>פגישה מאדם חדש פותחת ליד אוטומטית בCRM.</p>
        </div>
        <div className={styles.feature}>
          <h3>תזכורות חכמות</h3>
          <p>התראת meeting_soon 30 דקות לפני, עם הקשר של הלקוח / הפרויקט / הליד.</p>
        </div>
      </div>
    </div>
  );
}
